import { dialog } from "nq-component";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";
import DialogModal from "../../../../../components/Dialog";
import {
  computePartialCosts,
  computeTotalCost,
} from "../../../../../componentCostUtils";

class TransferHistoryFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    // Preserve raw_materials if present in the view
    if (!this.object.raw_materials && this.view.state.object?.raw_materials) {
      this.object.raw_materials = [...this.view.state.object.raw_materials];
    }

    this.view.setObject(this.object);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = {
        include: [
          "raw_materials",
          "raw_materials.uom",
          "uom",
          "sourceLocation",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  generateRequestNumber(prefix = "ANGELSPIZZA") {
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const yyyy = now.getFullYear();
    const randomDigits = Math.floor(1000 + Math.random() * 9000);

    return `${prefix}-${mm}${dd}${yyyy}-${randomDigits}`;
  }

  generateTransferNumber() {
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const yyyy = now.getFullYear();
    const randomDigits = Math.floor(1000 + Math.random() * 9000);
    return `TRANSFER-${mm}${dd}${yyyy}-${randomDigits}`;
  }

  async save() {
    this.view.showProgressDialog();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();

    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    const rawMaterials = computePartialCosts(
      this.view.state.object.raw_materials || []
    );
    this.change.raw_materials = rawMaterials;

    const now = new Date();
    const currentTimestamp = now.toISOString();
    this.change.requestDate = now.toISOString();
    this.change.requestNumber = this.generateRequestNumber();
    this.change.status = "Pending";
    this.change.requestedBy = { id: user.id };
    this.change.sourceLocation = { id: this.change.sourceLocation.id };
    this.change.destinationLocation = { id: user.storeAnalytic[0]?.id };
    this.change.items = this.change.raw_materials;
    delete this.change.raw_materials;

    console.log("save", this.change);

    try {
      const result = await this.upsertUseCase.execute(collection, this.change);

      const transfer = {
        transferNumber: this.generateTransferNumber(), // similar format function as requestNumber
        linkedRequestId: result.id,
        transferDate: now.toISOString(),
        requestDate: this.change.requestDate,
        // approvedDate: null, // will be updated later
        transferredBy: { id: user.id },
        sourceLocation: this.change.sourceLocation,
        destinationLocation: this.change.destinationLocation,
        items: this.change.items,
        remarks: this.change.remarks || "", // optional if remarks exist
        logsArray: [
          {
            status: "Pending",
            timestamp: currentTimestamp,
            updatedBy: {
              id: user.id,
              name: user.username || user.email,
            },
            remarks: "Transfer record created",
          },
        ],
        status: "Pending",
      };

      console.log("transfer", transfer);

      await this.upsertUseCase.execute("stock_transfers", transfer);

      this.change = {};
      this.view.hideProgressDialog();
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    // if (Object.values(this.change).length === 0) {
    //   this.view.showSuccessSnackbar("Successfully saved!");
    //   return;
    // }
    try {
      this.view.submitting();
      dialog.close();
      await this.save();

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default TransferHistoryFormPresenter;
